export default "__VITE_ASSET__JiruFKSD__"